<!-- =========================================================================================
    File Name: ResetPassword.vue
    Description: Reset Password Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img">
    <div class="vx-col sm:w-3/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row">
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg">
              <validation-observer #default="{valid}">
                <div class="vx-logo flex justify-items-center items-center pt-4">
                  <img src="@/assets/images/logo/logo.png" alt="logo" class="mx-auto" style="max-height: 25px"/>
                </div>
                <div class="p-4">
                  <div class="vx-card__title mb-8">
                    <h4 class="mb-4 grid justify-items-center">Recuperar Senha</h4>
                    <p>Por favor informe seu email e sua nova senha.</p>
                  </div>

                  <div class="flex flex-col gap-1">

                    <validation-provider
                      #default="{ errors }"
                      name="Email"
                      rules="required|email"
                    >
                      <vs-input
                        type="email"
                        label-placeholder="Email"
                        v-model="email"
                        class="w-full"
                      />
                      <label class="text-danger">
                        {{ errors[0] }}
                      </label>
                    </validation-provider>

                    <validation-provider
                      #default="{ errors }"
                      name="Senha"
                      rules="required|password"
                    >
                      <vs-input
                        type="password"
                        name="password"
                        v-validate="'required|verify_password'"
                        label-placeholder="Senha"
                        v-model="password"
                        class="w-full"
                        ref="password"
                        data-vv-as="password"
                      />
                      <label class="text-danger">
                        {{ errors[0] }}
                      </label>
                    </validation-provider>

                    <validation-provider
                      #default="{ errors }"
                      name="Confirmação Senha"
                      rules="required|password:@confirm"
                    >
                      <vs-input
                        type="password"
                        name="password_confirmation"
                        v-validate="'required|confirmed:password'"
                        label-placeholder="Confirmação Senha"
                        v-model="passwordConfirm"
                        class="w-full"
                        data-vv-as="password"
                      />
                      <label class="text-danger">
                        {{ errors[0] }}
                      </label>
                    </validation-provider>

                  </div>

                  <div class="flex flex-wrap justify-center gap-1 sm:flex-row">
                    <b-button
                      variant="primary"
                      :disabled="!valid"
                      @click="resetPassword">Recuperar</b-button>

                      <b-button
                        variant="outline-secondary"
                        class="float-right"
                        to="/login">
                        <feather-icon
                          icon="CornerUpLeftIcon"
                          class="mr-50"/>
                        <span class="align-middle">{{$t('back')}}</span>
                      </b-button>
                  </div>
                </div>
              </validation-observer>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import {
  BForm, BButton, BFormGroup, BInputGroup, BFormTextarea, BFormCheckbox, BCardText, BFormInput, BCard, BCardHeader, BCardTitle, BCardSubTitle, BCardBody, BCollapse, VBToggle, VBTogglePlugin
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email, password } from '@validations'

export default {
  components: {
    BForm,
    BButton,
    BFormGroup,
    BInputGroup,
    BFormTextarea,
    BCardText,
    BFormInput,
    BFormCheckbox,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardSubTitle,
    BCardBody,
    BCollapse,
    VBToggle,
    VBTogglePlugin,
    //----
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    token: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      email: '',
      password: '',
      passwordConfirm: ''
    }
  },
  methods: {
    resetPassword() {
      this.$vs.loading()
      const payload = {
        userDetails: {
          token: this.token,
          email: this.email,
          password: this.password,
          passwordConfirm: this.passwordConfirm
        },
        vs: this.$vs,
        closeAnimation: this.$vs.loading.close
      }
      this.$store.dispatch('auth/resetPassword', payload)
    }
  }
}
</script>
